export const customColors = {
  oceanBlueBg: "rgb(14, 77, 130)",
  oceanBlueText: "rgb(255, 255, 255)",

  skyBlueBg: "rgb(0, 122, 191)",
  skyBlueText: "rgb(255, 255, 255)",

  forestGreenBg: "rgb(68, 132, 62)",
  forestGreenText: "rgb(255, 255, 255)",

  slateGrayBg: "rgb(61, 65, 68)",
  slateGrayText: "rgb(255, 255, 255)",

  cloudGrayBg: "rgb(245, 245, 245)",
  cloudGrayText: "rgb(0, 0, 0)",

  midGrayBg: "rgb(225, 225, 225)",
  midGrayText: "rgb(0, 0, 0)",

  sunshineYellowBg: "rgb(252, 195, 78)",
  sunshineYellowText: "rgb(0, 0, 0)",
};

export type CustomColors = typeof customColors;
